module.exports = __webpack_public_path__ + "static/media/Ireland.c68eea12.png";